import { render, staticRenderFns } from "./OrderTypeEditor.vue?vue&type=template&id=158bfd8a"
import script from "./OrderTypeEditor.vue?vue&type=script&lang=js"
export * from "./OrderTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports